import React from "react";
import Facts from "components/Facts";
import map from "../map";

import windows7 from "assets/os/windows7.svg";
import windows8 from "assets/os/windows8.svg";
import windows10 from "assets/os/windows10.svg";
import windows11 from "assets/os/windows11.svg";
import osx from "assets/os/osx.svg";
import linux from "assets/os/linux.svg";
import ubuntu from "assets/os/ubuntu.svg";
import debian from "assets/os/debian.svg";
import freebsd from "assets/os/freebsd.svg";

const getLogo = (d) => {
  if (d == null) return null;
  const parts = d.split(":");
  const os = parts[0];
  const variant = parts[1];
  switch (os) {
    case "Windows":
      if (!variant) return windows10;
      const verparts = variant.split(".");
      const id = parseInt(verparts[2]);
      if (id < 9200) return windows7;
      if (id < 10240) return windows8;
      if (id < 22000) return windows10;
      return windows11;
    case "Mac OS X":
      return osx;
    case "Linux":
      switch (variant) {
        case "ubuntu":
          return ubuntu;
        case "debian":
          return debian;
        default:
          return linux;
      }
    case "FreeBSD":
      return freebsd;
  }
  return null;
};

const rad = 20;
const spc = 4;

export default {
  hasData: true,
  hasRag: true,
  collections: { processes: { objectType: "process" } },

  layout: { radius: rad + 1 },
  render: {
    enter: ({ elem: e, data, label }) => {
      e.append("circle")
        .attr("r", rad)
        .attr("fill", "white")
        .attr("stroke", "black")
        .attr("stroke-width", 0.5)
        .attr("title", label)
        .append("title")
        .text(label);
      e.append("image")
        .attr("x", -(rad - spc) / 1.42)
        .attr("y", -(rad - spc) / 1.42)
        .attr("width", ((rad - spc) * 2) / 1.42)
        .attr("height", ((rad - spc) * 2) / 1.42)
        .attr("href", getLogo(data))
        .append("title")
        .text(label);
    },
    update: ({ elem: e, data, label }) => {
      e.select("image").attr("href", getLogo(data));
    },
  },

  renderInfoHead: (t) => t.label,
  renderInfoBody: (t) => (
    <Facts>
      <Facts.Fact
        label="OS type"
        value={t.data == null ? "Unknown" : t.data.split(":")[0]}
      />
      <Facts.Fact
        label="OS variant"
        value={
          t.data == null || t.data.indexOf(":") == -1
            ? "Unknown"
            : t.data.split(":")[1]
        }
      />
      <Facts.Fact label="Known users" value={getKnownUsers(t)} />
    </Facts>
  ),
};

function getKnownUsers(t) {
  return (
    Object.keys(map.objects)
      .filter((k) => k.startsWith(t.id))
      .map((k) => map.objects[k])
      .filter((o) => o.type == "process" && o.data)
      .map((o) => JSON.parse(o.data).runningAs)
      .filter((v) => v)
      .join(", ") || "Unknown"
  );
}
